import Cookies from 'js-cookie';
import React, { createContext, ReactNode, useCallback, useContext, useEffect, useState } from 'react';
import Login from '../pages/Login/Login';
//import { message } from 'antd';
import { User as UserResponse } from '@/DTOS/User/Profile/User';
import { App } from 'antd';
import AuthentificationService from '../services/authentification/AuthentificationService';

// Define the shape of the context value
interface AuthContextType {
  isAuthenticated: boolean;
  profile: UserResponse | null;
}

// Create the context with default values
const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const initialCookieValue = Cookies.get('authu');
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(!!initialCookieValue);
  const [profile, setProfile] = useState<UserResponse | null>(null);
  const { message } = App.useApp();

  const handleResponse = useCallback((data: any) => {
    if (data && data?.response && data?.response?.name) {
      setIsAuthenticated(true);
      setProfile(data?.response);
    } else {
      setIsAuthenticated(false);
      setProfile(null);
    }
  }, []);

  const verifyProfile = useCallback(async () => {
    try {
      const response = await AuthentificationService.verifyProfile();
      handleResponse(response);
    } catch (error: any) {
      //message.error('Acces neautorizat');
    }
  }, [handleResponse]);

  const verifyCookie = useCallback(() => {
    const currentCookieValue = Cookies.get('authu');
    if (!currentCookieValue && isAuthenticated) {
      setIsAuthenticated(false);
      setProfile(null);
    } else if (currentCookieValue && currentCookieValue !== initialCookieValue) {
      setIsAuthenticated(true);
      setProfile(null);
      verifyProfile();
    }
  }, [initialCookieValue, isAuthenticated, verifyProfile]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      verifyCookie();
    }, 1000);

    return () => clearInterval(intervalId);
  }, [verifyCookie]);

  useEffect(() => {
    verifyProfile();
  }, [verifyProfile]);

  return (
    <AuthContext.Provider value={{ isAuthenticated, profile }}>
      {isAuthenticated ? children : <Login />}
    </AuthContext.Provider>
  );
};
